import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function Protected({ children, requireOnboarded = false }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-[var(--aa-text-3)]">
        <div className="aa-eyebrow">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
